import { render } from "./CurrentVehicleData.vue?vue&type=template&id=4623b5aa&scoped=true"
import script from "./CurrentVehicleData.vue?vue&type=script&lang=js"
export * from "./CurrentVehicleData.vue?vue&type=script&lang=js"

import "./CurrentVehicleData.vue?vue&type=style&index=0&id=4623b5aa&scoped=true&lang=css"
import "./CurrentVehicleData.vue?vue&type=style&index=1&id=4623b5aa&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4623b5aa"]])

export default __exports__